<template>
  <div class="detail-skill-page">
    <div class="skill-name">技能分析</div>
    <div class="skill-content">
      <div class="over-content">
        <div class="skill-box has-skill">
          <div class="skill-title">
            <i class="iconfont iconwancheng"></i>
            已掌握技能
          </div>
          <div class="skill-list">
            <template v-if="commonList.length > 0">
              <div class="skill-item" v-for="(item, index) in commonList" :key="index + 'me'">{{item}}</div>
            </template>
            <p v-else>暂无数据</p>
          </div>
        </div>
        <div class="skill-box not-has-skill">
          <div class="skill-title">
            <i class="iconfont iconcha"></i>
            欠缺技能
          </div>
          <div class="skill-list">
            <template v-if="lackList.length > 0">
              <div class="skill-item" v-for="(item, index) in lackList" :key="index + 'lackList'">{{item}}</div>
            </template>
            <p v-else>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "detail-skill",
    props: {
      skills: {
        type: Object,
        default: ()=>({
          me: [],
          all: []
        })
      }
    },
    computed: {
      lackList(){
        return this.skills.all.filter(item=> !this.skills.me.includes(item) && item != '其他')
      },
      commonList(){
        return this.skills.all.filter(item=> this.skills.me.includes(item) && item != '其他')
      }
    }
  }
</script>

<style scoped lang="scss">
.detail-skill-page{
  margin-bottom: 50px;
  .skill-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .skill-content{
    width: 1200px;
    height: 286px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/bgcard3.png");
    background-size: 100%;
    padding: 32px;
    box-sizing: border-box;
    .over-content{
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar{
        display: none;
      }
    }
    .skill-box{
      background: #252830;
      border-radius: 8px;
      padding: 24px 24px 12px 24px;
      display: flex;
      box-sizing: border-box;
      align-items: flex-start;
      .skill-title{
        display: flex;
        align-items: center;
        width: 122px;
        min-width: 122px;
        height: 34px;
        & > .iconfont{
          font-size: 18px;
          margin-right: 8px;
          &.iconwancheng{
            color: #7ada95;
          }
          &.iconcha{
            color: #FE7B5D;
          }
        }
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
      }
      .skill-list{
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        & > p{
          line-height: 34px;
          color: #fff;
          margin-bottom: 12px;
        }
        .skill-item{
          padding: 9px 15px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 14px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-sizing: border-box;
          border-radius: 17px;
          margin-right: 12px;
          margin-bottom: 12px;
        }
      }
    }
    .has-skill{
      margin-bottom: 12px;
    }
  }
}
</style>
